var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBorneDIstanceB(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 251,
    height: 251,
    viewBox: "0 0 251 251",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M164.558 55.6545H170.258V32.1445H159.038V37.0447H164.558V55.6545Z",
    fill: "#F97E73"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M181.228 55.9846C186.958 55.9846 191.128 53.5947 191.128 47.8147C191.128 42.8347 186.798 40.3748 181.508 40.3748C180.818 40.3748 180.108 40.4246 179.758 40.4846L180.138 37.0347H190.108V32.1348H175.638L174.098 44.5947L175.168 45.4946C176.638 44.9946 178.358 44.7546 180.188 44.7546C183.428 44.7546 185.058 45.9347 185.058 48.0447C185.058 50.1547 183.568 51.1248 180.568 51.1248C178.438 51.1248 176.178 50.6446 173.998 49.5146L173.198 54.3447C175.398 55.3647 178.288 55.9846 181.228 55.9846Z",
    fill: "#F97E73"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M215.688 55.6545H221.138V44.8547C221.138 40.8047 218.108 38.6946 214.908 38.6946C212.818 38.6946 210.668 39.5546 209.318 41.4546C208.438 39.6246 206.308 38.6946 204.088 38.6946C202.138 38.6946 200.128 39.2947 198.948 40.7847L198.778 39.0347H193.778V55.6545H199.228V46.4045C199.228 44.5545 200.628 43.6746 201.998 43.6746C203.368 43.6746 204.718 44.5545 204.718 46.4045V55.6545H210.168V46.4045C210.168 44.5545 211.608 43.6746 212.968 43.6746C214.328 43.6746 215.688 44.5545 215.688 46.4045V55.6545Z",
    fill: "#F97E73"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4482 192.165V180.965L57.3683 204.505V218.075L13.4482 192.165Z",
    fill: "#B2E8C5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M57.7583 205.775L13.4482 180.975L180.888 81.8447L220.988 101.675L57.7583 205.775Z",
    fill: "#72D09A"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M57.2383 218.395V205.135L220.998 101.565V112.995L57.2383 218.395Z",
    fill: "#29A063"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M29.0682 171.735L23.6782 174.905L51.3782 190.175L57.0082 186.645L29.0682 171.735Z",
    fill: "#F97E73"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M57.2484 155.045L51.8584 158.225L79.5484 173.515L85.1784 169.985L57.2484 155.045Z",
    fill: "#F97E73"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M42.5683 163.745L37.9783 166.475L56.1183 175.495L60.9983 172.385L42.5683 163.745Z",
    fill: "#F97E73"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M86.6283 137.655L81.2483 140.855L109.018 156.005L114.628 152.445L86.6283 137.655Z",
    fill: "#F97E73"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M114.128 121.305L108.768 124.535L136.628 139.525L142.218 135.935L114.128 121.305Z",
    fill: "#F97E73"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M99.3282 130.155L94.7283 132.865L112.828 141.985L117.718 138.895L99.3282 130.155Z",
    fill: "#F97E73"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M141.788 104.995L136.388 108.165L164.068 123.475L169.698 119.955L141.788 104.995Z",
    fill: "#FECECA"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M169.888 88.3547L164.508 91.5447L192.258 106.725L197.878 103.175L169.888 88.3547Z",
    fill: "#FECECA"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M154.878 97.2446L150.278 99.9646L168.408 109.025L173.288 105.925L154.878 97.2446Z",
    fill: "#FECECA"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M127.508 113.415L122.898 116.115L140.978 125.265L145.878 122.195L127.508 113.415Z",
    fill: "#FECECA"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M70.4584 147.205L65.8784 149.965L84.0684 158.885L88.9284 155.745L70.4484 147.205H70.4584Z",
    fill: "#F97E73"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBorneDIstanceB);
export default __webpack_public_path__ + "static/media/borneDIstanceB.c7dc4ba0bfca63093185c876939b7594.svg";
export { ForwardRef as ReactComponent };